import React, { Component } from 'react';
import { post } from '../../utils/http';
import api from '../../utils/api';
import CreateMerchant from './CreateMerchant';
import EditMerchant from './EditMerchant';
import { Table, Button, Popconfirm, Pagination, notification, Input, Layout } from 'antd';
import { UserAddOutlined } from '@ant-design/icons';

const { Search } = Input;


class MerchantManagement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            current: 1,
            pageSize: 10,
            total: 0,
            isOpenCreate: false,
            isOpenEdit: false,
            data: [],
            search: "",
            loading: false,
            editMerchant: {},
        }
    }

    columns = [
        {
            title: 'Merchant Name',
            key: 'merchantName',
            dataIndex: 'merchantName'
        }, {
            title: 'Mobile Number',
            key: 'mobileNumber',
            dataIndex: 'mobileNumber'
        }, {
            align:'center',
            fixed: 'right',
            title: 'Action',
            key: 'Action',
            render: (_, record) => {
                return (
                    <div style={{ display: 'flex', width:140, marginLeft:'auto', marginTop:0, marginRight:'auto', marginBottom:0 }}>
                        <Button type='primary' shape="round" style={{ marginRight: '10px' }} onClick={() => this.openEditModal(record)} >Edit</Button>
                        <Popconfirm title="Are you sure to delete this merchant?" onConfirm={() => this.handleDel(record.merchantId)}>
                            <Button type='primary' shape="round">Delete</Button>
                        </Popconfirm>
                    </div>
                )
            }
        },
    ];


    openCreateModal = () => {
        this.setState({ isOpenCreate: true })
    }

    closeCreateModal = () => {
        this.setState({ isOpenCreate: false })
    }

    openEditModal = (record) => {
        this.setState({ isOpenEdit: true, editMerchant: record })
    }

    closeEditModal = () => {
        this.setState({ isOpenEdit: false })
    }

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, () => {
            this.handleSearch(false)
        })
    };

    getSearch = (value) => {
        this.setState({ loading: true, search: value }, () => {
            this.handleSearch(true)
        })
    };

    handleChangePage = (current, pageSize) => {
        this.setState({ current: current, pageSize: pageSize, loading: true }, () => {
            this.handleSearch(false)
        })
    }

    handleDel = (merchantId) => {
        this.setState({ loading: true })
        var delData = new FormData()
        delData.append("merchantId", merchantId)
        var _this = this;
        post(api.deleteMerchant, delData).then(function (response) {
            notification['success']({
                message: 'Delete successfully.',
            });
            _this.handleSearch(true);
        }).catch(function (error) {
            notification['error']({
                message: 'Fail to delete.',
            });
            _this.setState({ loading: false })
            console.log('error', error);
        })
    }

    handleSearch = (flag) => {
        this.setState({ loading: true })
        let { search, pageSize, current } = this.state;
        let data;
        if (flag) {
            data = { pageNum: 1, pageSize: pageSize, search: search }
        } else {
            data = { pageNum: current, pageSize: pageSize, search: search }
        }
        var _this = this;
        post(api.merchantList, data).then(function (response) {
            var { total, currentPage, pageSize, rows } = response
            _this.setState({
                current: currentPage,
                pageSize: pageSize,
                total: total,
                data: rows,
                loading: false
            })
        }).catch(function (error) {
            notification['error']({
                message: 'Fail to search',
            });
            console.log(error)
            _this.setState({
                loading: false
            })
        })
    }

    componentWillMount() {
        this.handleSearch(true)
    }

    render() {
        const { data, current, total, loading } = this.state;
        return (
            <Layout>
                <div style={{ backgroundColor: "white", display: "flex", justifyContent: "space-between", marginBottom: "10px", padding: "20px" }}>
                    <Search size="large" placeholder="Search merchant name" onSearch={this.getSearch} style={{ width: '400px' }} />
                    <Button icon={<UserAddOutlined />} type="primary" size="large" onClick={this.openCreateModal}> New Merchant</Button>
                </div>
                <Table
                    scrollToFirstRowOnChange={true}
                    scroll={{ x: '100%', y: 360 }}
                    columns={this.columns}
                    rowKey={record => record.merchantId}
                    dataSource={data}
                    pagination={false}
                    loading={loading} />
                <Pagination style={{ marginTop: '5px' }} current={current} showSizeChanger={true} total={total} onChange={this.handleChangePage} />
                {this.state.isOpenCreate && <CreateMerchant isOpenCreate={this.state.isOpenCreate} closeCreateModal={this.closeCreateModal} handleSearch={this.handleSearch} />}
                {this.state.isOpenEdit && <EditMerchant isOpenEdit={this.state.isOpenEdit} closeEditModal={this.closeEditModal} handleSearch={this.handleSearch} editValue={this.state.editMerchant} />}
            </Layout>
        )
    }
}
export default MerchantManagement;